const initialState = {
  dataView: {},
  dataViewSummary: {},
  dataViewHash: {},
  dataViews: [],
  fetching: false,
  fetched: false,
  error: null,
}

export default function reducer(state = initialState, action) {

  switch (action.type) {
    case "COMBINED_DATA_VIEWS_FETCH_PENDING":
    case "CHILD_COMPANY_COMBINED_DATA_VIEWS_FETCH_PENDING":
      return {
        ...state,
        fetching: true,
        fetched: false,
        error: null,
      }
    case "COMBINED_DATA_VIEWS_FETCH_REJECTED":
    case "CHILD_COMPANY_COMBINED_DATA_VIEWS_FETCH_REJECTED":
      return {
        ...state,
        fetching: false,
        error: action.payload.response ? action.payload.response.data.errors : action.payload.message,
      }
    case "COMBINED_DATA_VIEWS_FETCH_FULFILLED":
    case "CHILD_COMPANY_COMBINED_DATA_VIEWS_FETCH_FULFILLED":
      return {
        ...state,
        fetching: false,
        fetched: true,
        dataViews: action.payload.data,
        error: null,
      }
    case "COMBINED_DATA_VIEW_FETCH_PENDING":
      return {
        ...state,
        fetching: true,
        fetched: false,
        dataViews: null,
      }
    case "COMBINED_DATA_VIEW_FETCH_REJECTED":
      return {
        ...state,
        fetching: false,
        error: action.payload.response ? action.payload.response.data.errors : action.payload.message,
      }
    case "COMBINED_DATA_VIEW_FETCH_FULFILLED":
      return {
        ...state,
        fetching: false,
        fetched: true,
        dataView: action.payload.data,
      }
    case "COMBINED_DATA_VIEW_HASH_FETCH_PENDING":
      return {
        ...state,
        fetching: true,
        fetched: false,
        dataViewHash: null,
      }
    case "COMBINED_DATA_VIEW_HASH_FETCH_REJECTED":
      return {
        ...state,
        fetching: false,
        fetched: false,
        error: action.payload.response ? action.payload.response.data.errors : action.payload.message,
      }
    case "COMBINED_DATA_VIEW_HASH_FETCH_FULFILLED":
      return {
        ...state,
        fetching: false,
        fetched: true,
        dataViewHash: action.payload.data
      }
    case  'USER_SIGN_OUT_PENDING':
      return {
        ...initialState
      }
    case 'USER_SIGN_OUT_FULFILLED':
      return {
        ...initialState
      }
    default:
      return state

  }

}



// WEBPACK FOOTER //
// ./src/reducers/combinedDataViewsReducer.js